<template>
  <div>
    <div class="container-fluid featured-page-image">
      <div class="feature-header-page">
        <h1>Contact</h1>
      </div>
    </div>
    <div class="container mb-3">
      <div class="row">
        <div class="col-sm-12 intro">
          <h2>Contact with KD-Roofing</h2>
          <hr />
        </div>
        <div class="col-xl-4 col-lg-12 contact-section">
          <div class="row contacts">
            <div class="col-sm-2 col-md-2 col-lg-2 contact-us-labels">
              <p>
                <strong>Tel:</strong>
              </p>
              <p>
                <strong>Email:</strong>
              </p>
            </div>
            <div class="col-sm-10 col-md-6 col-xl-10 contact-us-links">
              <p>
                <a href="tel:07912877887">07912 877887</a>
              </p>
              <p>
                <a href="mailto:info@kd-roofing.com">info@kd-roofing.com</a>
              </p>
            </div>
            <div
              class="col-sm-6 col-md-4 col-xl-12 mt-3 mt-md-0 mt-xl-3 text-md-right text-xl-left contact-us-address"
            >
              <p>75 Manson Green</p>
              <p>Hingham</p>
              <p>Norfolk</p>
              <p>NR9 4PZ UK</p>
            </div>
          </div>
        </div>
        <div class="col-xl-8 col-lg-12 contact-section">
          <div id="notices">
            <div v-if="errors.length" class="errors">
              <p>Please correct the following error(s):</p>
              <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </div>
            <div v-if="success" class="success">
              <b>Your message has been sent successfully</b>
            </div>
          </div>
          <netlify-form name="contact-form" netlify-honeypot="bot-field">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="first-name" class="required">First name</label>
                <input
                  v-model="firstName"
                  name="firstName"
                  id="first-name"
                  class="form-control"
                  type="text"
                  placeholder="Your first name"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="last-name" class="required">Last name</label>
                <input
                  v-model="lastName"
                  name="lastName"
                  id="last-name"
                  class="form-control"
                  type="text"
                  placeholder="Your last name"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="email-name" class="required">Email</label>
                <input
                  v-model="email"
                  name="email"
                  id="email-name"
                  class="form-control"
                  type="email"
                  placeholder="Your email"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="phone" class="required">Phone</label>
                <input
                  v-model="phone"
                  name="phone"
                  id="phone"
                  class="form-control"
                  type="text"
                  placeholder="Your phone"
                />
              </div>
              <div class="form-group col-md-12">
                <label for="message" class="required">Your message</label>
                <textarea
                  v-model="message"
                  name="message"
                  id="message"
                  class="form-control"
                  placeholder="Your message"
                  rows="5"
                ></textarea>
              </div>
              <div class="col">
                <label class="required">GDPR Agreement</label>
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="gdpr"
                    class="custom-control-input"
                    type="checkbox"
                    name="checkbox"
                    id="checkbox"
                    required
                  />
                  <label for="checkbox" class="custom-control-label">
                    I consent to having this website store my submitted
                    information so they can respond to my enquiry.
                  </label>
                </div>
              </div>
              <div class="form-group col-md-12">
                <button
                  @click="onSubmit"
                  type="submit"
                  class="form-button button-secondary btn mt-4"
                >Submit</button>
              </div>
            </div>
          </netlify-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NetlifyForm from "@/components/forms/NetlifyForm";

export default {
  name: "Contact",
  components: {
    NetlifyForm,
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      message: null,
      gdpr: false,
      errors: [],
      success: false,
    };
  },
  methods: {
    onSubmit(e) {
      this.errors = [];
      this.success = false;

      if (!this.firstName) {
        this.errors.push("First Name required");
      }
      if (!this.lastName) {
        this.errors.push("Last Name required");
      }
      if (!this.email) {
        this.errors.push("Email required");
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Valid email required");
      }
      if (!this.phone || !this.validPhoneNumber(this.phone)) {
        this.errors.push("Valid phone number required");
      }
      if (!this.message) {
        this.errors.push("Message required");
      }
      if (!this.gdpr) {
        this.errors.push(
          "We are unable to submit your enquiry, without consent to hold your data"
        );
      }
      if (this.errors.length) {
        e.preventDefault();
      }

      setTimeout(() => {
        console.log("SCROLL");
        document.querySelector("#notices").scrollIntoView();
      }, 200);
    },
    validEmail: function (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhoneNumber: function (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[()]+/g, "");
      let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/;
      return number.test(phoneNumber);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue